"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRehydrationData = getRehydrationData;

function getRehydrationData() {
  var overridesScript = document.getElementById('__OUTSMARTLY_DATA__');

  if (!overridesScript) {
    console.error("No <script id=\"__OUTSMARTLY_DATA__\" type=\"application/json\"> could be found.");
    return '';
  }

  return overridesScript.textContent;
}